import moment from 'moment';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { DateModelOptions, DateModelOptionsFromJson, JsonDateModelOptions } from '../options/date-model-options';
import { PrimitiveModel } from './primitive.model';
import { DateUtilities } from '../../utilities/date-utilities';

export class DateModel extends PrimitiveModel {
    public constructor(
        public name: string,
        public value: moment.Moment = moment.invalid(),
        public options = new DateModelOptions(),
    ) {
        super(name, value, options);
    }

    /**
     * Convert the internal data into an object suitable for OData exchange with SAP
     *
     * @returns {object} the internal value in a format suitable for SAP
     */
    public getOutModel(): ODataDateOutModel {
        const outModel: ODataDateOutModel = {};
        const format = this.options.format;

        outModel[this.name] = this.value.isValid() ? this.value.format(format) : null;

        return outModel;
    }

    public get formattedDisplayedDate(): string {
        return DateUtilities.formatDate(this.value);
    }
}

export class DateModelFromJson extends DateModel {
    public constructor(data: JsonDateModel) {
        super(data.name, moment(data.value), new DateModelOptionsFromJson(data.options));
    }
}

export interface JsonDateModel {
    name: string;
    value: string;
    options: JsonDateModelOptions;
}

export interface ODataDateOutModel extends ODataObject {
    [key: string]: string | null;
}
